export enum Permissions {
  NONE = 'none',

  //Settings Module Permissions
  LIST_CHARGE = 'list-charge',
  CREATE_CHARGE = 'create-charge',
  UPDATE_CHARGE = 'update-charge',
  APPROVE_CHARGE = 'approve-charge',
  ENABLE_CHARGE = 'enable-charge',
  ACTIVATE_CHARGE = 'activate-charge',
  REJECT_CHARGE = 'reject-charge',
  DISABLE_CHARGE = 'disable-charge',
  CREATE_LOAN_PRODUCT = 'create-loan-product',
  LIST_LOAN_PRODUCT = 'list-loan-product',
  CREATE_CURRENT_PRODUCT = 'create-current-product',
  LIST_CURRENT_PRODUCT = 'list-current-product',
  CREATE_INTERNAL_ACCOUNT = 'create-internal-account',
  LIST_INTERNAL_ACCOUNT = 'list-internal-account',
  LIST_ROLES = 'list-role',
  CREATE_ROLE = 'create-role',
  VIEW_ROLE = 'view-role',
  DELETE_ROLE = 'delete-role',
  APPROVE_ROLE = 'approve-role',
  LIST_HOLIDAY = 'list-holiday',
  CREATE_HOLIDAY = 'create-holiday',
  APPROVE_HOLIDAY = 'approve-holiday',
  REJECT_HOLIDAY = 'reject-holiday',
  CREATE_CLIENT_SETUP = 'create-client-setup',
  EDIT_CLIENT_SETUP = 'edit-client-setup',
  VIEW_CLIENT_SETUP = 'view-client-setup',
  LIST_CONTRACT = 'list-contract',
  VIEW_CONTRACT = 'view-contract',
  INITIATE_APPROVAL_LIMIT = 'initiate-modify-approval-limit',
  APPROVE_APPROVAL_LIMIT = 'approve-modify-approval-limit',
  INITIATE_MODIFY_POSTING_BACKDATE_LIMIT = 'initiate-modify-posting-backdate-limit',
  APPROVE_MODIFY_POSTING_BACKDATE_LIMIT = 'approve-modify-posting-backdate-limit',

  LIST_AREA = 'list-area',
  CREATE_AREA = 'create-area',
  ENABLE_AREA = 'enable-area',
  DISABLE_AREA = 'disable-area',
  APPROVE_AREA = 'approve-area',
  ACTIVATE_AREA = 'activate-area',
  REJECT_AREA = 'reject-area',

  LIST_BRANCH = 'list-branch',
  CREATE_BRANCH = 'create-branch',
  BULK_LOAN_APPROVE_OTHER_BRANCHES = 'bulk-loan-approve-other-branches',
  ENABLE_BRANCH = 'enable-branch',
  DISABLE_BRANCH = 'disable-branch',
  APPROVE_BRANCH = 'approve-branch',
  ACTIVATE_BRANCH = 'activate-branch',
  REJECT_BRANCH = 'reject-branch',

  CREATE_CONTRACT = 'create-contract',

  LIST_SAVINGS_PRODUCT = 'list-deposit-product',
  CREATE_SAVINGS_PRODUCT = 'create-deposit-product',
  ENABLE_SAVINGS_PRODUCT = 'enable-deposit-product',
  DISABLE_SAVINGS_PRODUCT = 'disable-deposit-product',
  APPROVE_SAVINGS_PRODUCT = 'approve-deposit-product',
  ACTIVATE_SAVINGS_PRODUCT = 'activate-deposit-product',
  REJECT_SAVINGS_PRODUCT = 'reject-deposit-product',

  //Dashboard Module Permissions
  VIEW_DASHBOARD_STAT = 'view-dashboard-stat',
  SHOW_CLIENTS_PER_BRANCH_CHART = 'show-clients-per-branch-chart',
  SHOW_DAILY_REPAYMENT_CHAART = 'show-daily-repayment-chart',
  SHOW_SAVINGS_PER_BRANCH_CHART = 'show-savings-per-branch-chart',
  SHOW_AMOUNT_WRITTEN_OFF_CHART = 'show-amount-written-off-chart',
  SHOW_RECENT_ACTIVITIES_TABLE = 'show-recent-activities-table',
  PAR_PER_BRANCH = 'par-per-branch',
  LOGGED_IN_USERS = 'logged-in-users',
  MY_DISBURSEMENTS = 'my-disbursements',

  /**
   * Client (Individual) Module Permissions
   *
   * NOTE: string values must match the permission codes in the core DB
   * (`permission` table / reference-seed.sql). The DB uses the short codes
   * (e.g. 'list-client') — the '*-individual-client' rename was never applied
   * backend-side, and shipping it here locked every non-super user out of the
   * client pages (PermissionGuard). Do not rename these values unless the DB
   * codes are migrated first.
   */
  CREATE_CLIENT = 'create-client',
  LIST_CLIENT = 'list-client',
  VIEW_CLIENT = 'view-client',
  APPROVE_CLIENT = 'approve-client',
  REJECT_CLIENT = 'reject-client',
  ENABLE_CLIENT = 'enable-client',
  DISABLE_CLIENT = 'disable-client',
  ACTIVATE_CLIENT = 'activate-client',
  RESTORE_REJECTED_CLIENT = 'restore-rejected-client',
  EDIT_CLIENT = 'edit-client',
  EDIT_CLIENT_DATE_OF_BIRTH = 'edit-client-date-of-birth',
  EDIT_BVN_DETAILS = 'edit-bvn-details',
  UPDATE_KYC_STATUS = 'update-kyc-status',
  LIST_KYC_REQUESTS = 'list-kyc-requests',
  VIEW_CLIENT_KYC = 'view-client-kyc',
  CREATE_GROUP = 'create-group',

  CREATE_CORPORATE_CLIENT = 'create-corporate-client',
  LIST_CORPORATE_CLIENT = 'list-corporate-client',
  VIEW_CORPORATE_CLIENT = 'view-corporate-client',
  EDIT_CORPORATE_CLIENT = 'edit-corporate-client',
  APPROVE_CORPORATE_CLIENT = 'approve-corporate-client',
  APPROVE_EDIT_CORPORATE_CLIENT = 'approve-edit-corporate-client',
  ACTIVATE_CORPORATE_CLIENT = 'activate-corporate-client',
  DISABLE_CORPORATE_CLIENT = 'disable-corporate-client',
  ENABLE_CORPORATE_CLIENT = 'enable-corporate-client',
  REJECT_CORPORATE_CLIENT = 'reject-corporate-client',
  RESTORE_CORPORATE_CLIENT = 'restore-rejected-corporate-client',
  EDIT_CORPORATE_CLIENT_NOTIFICATION = 'edit-corporate-client-notification',
  VIEW_CORPORATE_CLIENT_NOTIFICATION = 'view-corporate-client-notification',

  LIST_GROUP = 'list-group',
  VIEW_GROUP = 'view-group',
  APPROVE_GROUP = 'approve-group',
  DELETE_GROUP = 'delete-group',
  DELETE_CLIENT_DOCUMENT = 'delete-client-document',
  DISABLE_GUARANTOR = 'disable-guarantor',
  ENABLE_GUARANTOR = 'enable-guarantor',
  UPDATE_GUARANTOR_MULTIPLE = 'update-guarantor-multiple',

  //Staff Module Permissions
  CREATE_STAFF = 'create-staff',
  LIST_STAFF = 'list-staff',
  STAFF_APPROVE = 'staff-approve',
  STAFF_REJECT = 'staff-reject',
  STAFF_DISABLE = 'staff-disable',
  STAFF_ENABLE = 'staff-enable',

  // Staff module (role-gated by the backend; codes must be listed here or
  // PermissionService.evaluateUsersPermissions drops them)
  VIEW_STAFF = 'view-staff',
  EDIT_STAFF = 'edit-staff',
  APPROVE_STAFF_EDIT = 'approve-staff-edit',
  APPROVE_STAFF = 'approve-staff',
  ENABLE_DISABLE_STAFF = 'enable-disable-staff',
  VIEW_STAFF_PERMISSIONS = 'view-staff-permissions',
  MANAGE_STAFF_PERMISSIONS = 'manage-staff-permissions',
  VIEW_STAFF_PROFILE = 'view-staff-profile',
  EDIT_STAFF_PROFILE = 'edit-staff-profile',
  VIEW_STAFF_EMPLOYMENT = 'view-staff-employment',
  EDIT_STAFF_EMPLOYMENT = 'edit-staff-employment',
  VIEW_STAFF_DOCUMENTS = 'view-staff-documents',
  MANAGE_STAFF_DOCUMENTS = 'manage-staff-documents',
  VIEW_STAFF_LOAN_ACCOUNTS = 'view-staff-loan-accounts',
  VIEW_STAFF_DEPOSIT_ACCOUNTS = 'view-staff-deposit-accounts',
  VIEW_STAFF_SETTINGS = 'view-staff-settings',
  MANAGE_STAFF_SETTINGS = 'manage-staff-settings',
  VIEW_LEAVE_REQUESTS = 'view-leave-requests',
  CREATE_LEAVE_REQUEST = 'create-leave-request',
  APPROVE_LEAVE_REQUEST = 'approve-leave-request',
  REJECT_LEAVE_REQUEST = 'reject-leave-request',
  CANCEL_LEAVE_REQUEST = 'cancel-leave-request',
  VIEW_LEAVE_POLICIES = 'view-leave-policies',
  CREATE_LEAVE_POLICY = 'create-leave-policy',
  EDIT_LEAVE_POLICY = 'edit-leave-policy',
  DELETE_LEAVE_POLICY = 'delete-leave-policy',
  VIEW_HR_POLICIES = 'view-hr-policies',
  CREATE_HR_POLICY = 'create-hr-policy',
  EDIT_HR_POLICY = 'edit-hr-policy',
  DELETE_HR_POLICY = 'delete-hr-policy',
  VIEW_POLICY_COMPLIANCE = 'view-policy-compliance',
  SEND_POLICY_REMINDER = 'send-policy-reminder',
  EXPORT_POLICY_COMPLIANCE = 'export-policy-compliance',
  VIEW_APPRAISALS = 'view-appraisals',
  CREATE_APPRAISAL = 'create-appraisal',
  VIEW_APPRAISAL_FINANCIALS = 'view-appraisal-financials',
  VIEW_APPRAISAL_SETTINGS = 'view-appraisal-settings',
  MANAGE_APPRAISAL_SETTINGS = 'manage-appraisal-settings',

  //User Module Permissions
  CREATE_USER = 'create-user',
  LIST_USERS = 'list-users',
  UPDATE_USER_ROLE = 'update-user-role',
  USER_ACTIVATE = 'user-activate',
  USER_ENABLE = 'user-enable',
  USER_DISABLE = 'user-disable',

  //Loan Module Permissions
  CREATE_CLIENT_LOAN_ACCOUNT = 'create-client-loan-account',
  LIST_CLIENT_LOAN_ACCOUNT = 'list-client-loan-account',
  VIEW_CLIENT_LOAN_ACCOUNT = 'view-client-loan-account',
  APPROVE_CLIENT_LOAN_ACCOUNT = 'approve-client-loan-account',
  REJECT_CLIENT_LOAN_ACCOUNT = 'reject-client-loan-account',
  POST_CLIENT_LOAN_REPAYMENT = 'post-client-loan-repayment',
  DISBURSE_CLIENT_LOAN = 'disburse-client-loan',
  APPROVE_CLIENT_LOAN_REPAYMENT = 'approve-client-loan-repayment',
  DECLINE_CLIENT_LOAN_REPAYMENT = 'decline-client-loan-repayment',
  WRITE_OFF_LOAN = 'write-off-loan',
  WAIVE_LOAN_INTEREST = 'waive-loan-interest',
  CANCEL_CLIENT_LOAN = 'cancel-client-loan',
  REVERSE_LOAN_TRANSACTION = 'reverse-loan-transaction',
  BACKDATE_LOAN_DISBURSEMENT = 'backdate-loan-disbursement',
  BACKDATE_LOAN_REPAYMENT = 'backdate-loan-repayment',
  REFUND_CLIENT_LOAN = 'refund-client-loan',
  UPDATE_FIRST_DISBURSEMENT_DATE = 'update-first-disbursement-date',
  EDIT_DATE_FOR_DISBURSEMENT = 'edit-date-for-disbursement',
  EDIT_DATE_FOR_LOAN_APPROVAL = 'edit-date-for-loan-approval',
  WAIVE_LATE_PENALTY_PAYMENT = 'waive-late-payment-penalty',
  BOOK_MULTIPLE_LOANS = 'book-multiple-loans',
  MODIFY_LOAN_SIZE = 'loan-size',
  MODIFY_LOAN_TERM = 'loan-term',
  MODIFY_LOAN_PRODUCT = 'loan-product',
  MODIFY_INTEREST_RATE = 'interest-rate',
  MODIFY_GRACE_PERIOD = 'grace-period',
  MODIFY_REPAYMENT_FREQUENCY = 'repayment-frequency',
  // Loan creation: the product's terms a loan officer may change for a loan.
  EDIT_DESCRIPTION = 'edit-description',
  EDIT_INTEREST_RATE_UNIT = 'edit-interest-rate-unit',
  EDIT_LOAN_TERM_UNIT = 'edit-loan-term-unit',
  EDIT_REPAYMENT_FREQUENCY_UNIT = 'edit-repayment-frequency-unit',
  EDIT_GRACE_PERIOD_UNIT = 'edit-grace-period-unit',
  EDIT_ASSET_FINANCE_VALUE = 'edit-asset-finance-value',
  EDIT_ASSET_FINANCE_INSURANCE_UNIT = 'edit-asset-finance-insurance-unit',
  EDIT_ASSET_FINANCE_INSURANCE_VALUE = 'edit-asset-finance-insurance-value',
  EDIT_ASSET_FINANCE_DOWN_PAYMENT = 'edit-asset-finance-down-payment',
  EDIT_ASSET_FINANCE_PENALTY_SWITCH = 'edit-asset-finance-penalty-switch',
  EDIT_ASSET_FINANCE_DISBURSEMENT_METHOD = 'edit-asset-finance-disbursement-method',
  MULTIPLE_RUNNING_LOANS = 'multiple-running-loans',
  MODIFY_CLOSED_LOAN_DOCUMENTS = 'modify-closed-loan-documents',
  AUTHORIZE_CLIENT_LOAN_ACCOUNT = 'authorize-client-loan-account',

  //Posting Module Permissions
  CREATE_GROUP_POSTING = 'create-group-posting',
  LIST_GROUP_POSTING = 'list-group-posting',
  APPROVE_GROUP_POSTING = 'approve-group-posting',
  REJECT_GROUP_POSTING = 'reject-group-posting',
  VIEW_GROUP_POSTING = 'view-group-posting',
  CREATE_BRANCH_WIDE_GROUP_POSTING = 'create-branch-wide-group-posting',
  BACK_DATE_GROUP_POSTING = 'back-date-group-posting',
  CREATE_INTER_BRANCH_POSTING = 'create-inter-branch-posting',

  // Savings/Deposit Module Permissions
  CREATE_CLIENT_SAVINGS_ACCOUNT = 'create-client-deposit-account',
  LIST_CLIENT_SAVINGS_ACCOUNT = 'list-client-deposit-account',
  APPROVE_CLIENT_SAVINGS_ACCOUNT = 'approve-client-deposit-account',
  REJECT_CLIENT_SAVINGS_ACCOUNT = 'reject-client-deposit-account',
  POST_SAVINGS_ACCOUNT_DEPOSIT = 'post-deposit-account-deposit',
  POST_SAVINGS_ACCOUNT_WITHDRAWAL = 'post-savings-account-withdrawal',
  REVERSE_SAVINGS_TRANSACTION = 'reverse-savings-transaction',
  POST_SAVINGS_FUND_TRANSFER = 'post-savings-fund-transfer',
  DEPOSIT_REVERSAL = 'deposit-reversal',
  DEPOSIT_ENABLE = 'deposit-enable',
  DEPOSIT_DISABLE = 'deposit-disable',
  DEPOSIT_TRANSFER = 'deposit-transfer',

  POST_DEPOSIT_TRANSACTION = 'post-deposit-transaction',
  APPROVE_DEPOSIT_TRANSACTION = 'approve-deposit-transaction',
  REJECT_DEPOSIT_TRANSACTION = 'reject-deposit-transaction',

  POST_WITHDRAWAL_TRANSACTION = 'post-withdrawal-transaction',
  APPROVE_WITHDRAWAL_TRANSACTION = 'approve-withdrawal-transaction',
  REJECT_WITHDRAWAL_TRANSACTION = 'reject-withdrawal-transaction',

  POST_TRANSFER_TRANSACTION = 'post-transfer-transaction',
  APPROVE_TRANSFER_TRANSACTION = 'approve-transfer-transaction',
  REJECT_TRANSFER_TRANSACTION = 'reject-transfer-transaction',

  // Deposit account creation: the product's terms a user may change for a
  // deposit account, each opened by its own permission (mirrors the loan
  // account's ADJUSTABLE_TERMS above).
  EDIT_DEPOSIT_INTEREST_RATE = 'edit-deposit-interest-rate',
  EDIT_DEPOSIT_INTEREST_RATE_UNIT = 'edit-deposit-interest-rate-unit',
  EDIT_DEPOSIT_INTEREST_CALCULATION = 'edit-deposit-interest-calculation',
  EDIT_DEPOSIT_COMPOUNDING_PERIOD_UNIT = 'edit-deposit-compounding-period-unit',
  EDIT_DEPOSIT_MINIMUM_BALANCE = 'edit-deposit-minimum-balance',
  EDIT_ALLOW_OVERDRAFT = 'edit-allow-overdraft',
  EDIT_OVERDRAFT_LIMIT = 'edit-overdraft-limit',
  EDIT_OVERDRAFT_INTEREST_RATE = 'edit-overdraft-interest-rate',
  EDIT_OVERDRAFT_INTEREST_RATE_UNIT = 'edit-overdraft-interest-rate-unit',
  EDIT_OVERDRAFT_INTEREST_CALCULATION = 'edit-overdraft-interest-calculation',
  EDIT_OVERDRAFT_COMPOUNDING_PERIOD_UNIT = 'edit-overdraft-compounding-period-unit',
  EDIT_FIXED_DEP_AMOUNT = 'edit-fixed-dep-amount',
  EDIT_FIXED_DEP_DURATION = 'edit-fixed-dep-duration',
  EDIT_FIXED_DEP_DURATION_UNIT = 'edit-fixed-dep-duration-unit',
  EDIT_FIXED_DEP_INTEREST_RATE = 'edit-fixed-dep-interest-rate',
  EDIT_FIXED_DEP_INTEREST_RATE_UNIT = 'edit-fixed-dep-interest-rate-unit',
  EDIT_FIXED_DEP_COMPOUNDING_PERIOD_UNIT = 'edit-fixed-dep-compounding-period-unit',
  EDIT_FIXED_DEP_ALLOW_PREMATURE_WITHDRAWAL = 'edit-fixed-dep-allow-premature-withdrawal',
  EDIT_FIXED_DEP_ALLOW_AUTO_ROLLOVER = 'edit-fixed-dep-allow-auto-rollover',
  EDIT_TARGET_SAVINGS_AMOUNT = 'edit-target-savings-amount',
  EDIT_TARGET_SAVINGS_DURATION = 'edit-target-savings-duration',
  EDIT_TARGET_SAVINGS_DURATION_UNIT = 'edit-target-savings-duration-unit',
  EDIT_TARGET_SAVINGS_INTEREST_RATE = 'edit-target-savings-interest-rate',
  EDIT_TARGET_SAVINGS_INTEREST_RATE_UNIT = 'edit-target-savings-interest-rate-unit',
  EDIT_TARGET_SAVINGS_COMPOUNDING_PERIOD_UNIT = 'edit-target-savings-compounding-period-unit',
  EDIT_TARGET_SAVINGS_SOURCE = 'edit-target-savings-source',
  EDIT_TARGET_SAVINGS_FREQUENCY_UNIT = 'edit-target-savings-frequency-unit',
  EDIT_TARGET_SAVINGS_DAY_OF_MONTH = 'edit-target-savings-day-of-month',
  EDIT_TARGET_SAVINGS_GRACE_PERIOD = 'edit-target-savings-grace-period',
  EDIT_TARGET_SAVINGS_MISSED_PENALTY = 'edit-target-savings-missed-penalty',
  EDIT_TARGET_SAVINGS_ALLOW_EARLY_WITHDRAWAL = 'edit-target-savings-allow-early-withdrawal',
  EDIT_TARGET_SAVINGS_AT_COMPLETION = 'edit-target-savings-at-completion',
  EDIT_TARGET_SAVINGS_ALLOW_FORFEIT_BONUS = 'edit-target-savings-allow-forfeit-bonus',
  EDIT_TARGET_SAVINGS_BONUS = 'edit-target-savings-bonus',
  EDIT_FORFEIT_BONUS_ON_EARLY_WITHDRAWAL = 'edit-target-savings-allow-forfeit-bonus',

  // Corporate Deposit Account Permissions
  CREATE_CORPORATE_CLIENT_DEPOSIT_ACCOUNT = 'create-corporate-client-deposit-account',
  LIST_CORPORATE_CLIENT_DEPOSIT_ACCOUNT = 'list-corporate-client-deposit-account',
  APPROVE_CORPORATE_CLIENT_DEPOSIT = 'approve-corporate-client-deposit',
  REJECT_CORPORATE_CLIENT_DEPOSIT = 'reject-corporate-client-deposit',

  //Transfer Module Permissions
  CREATE_CLIENT_TRANSFER = 'create-client-transfer',
  LIST_CLIENT_TRANSFER = 'list-client-transfer',
  APPROVE_CLIENT_TRANSFER = 'approve-client-transfer',
  REJECT_CLIENT_TRANSFER = 'reject-client-transfer',
  CREATE_GROUP_TRANSFER = 'create-group-transfer',
  LIST_GROUP_TRANSFER = 'list-group-transfer',
  APPROVE_GROUP_TRANSFER = 'approve-group-transfer',
  REJECT_GROUP_TRANSFER = 'reject-group-transfer',
  CREATE_LOAN_OFFICER_TRANSFER = 'create-loan-officer-transfer',
  LIST_LOAN_OFFICER_TRANSFER = 'list-loan-officer-transfer',
  APPROVE_LOAN_OFFICER_TRANSFER = 'approve-loan-officer-transfer',
  REJECT_LOAN_OFFICER_TRANSFER = 'reject-loan-officer-transfer',
  CREATE_BRANCH_TRANSFER = 'create-branch-transfer',
  LIST_BRANCH_TRANSFER = 'list-branch-transfer',
  APPROVE_BRANCH_TRANSFER = 'approve-branch-transfer',
  REJECT_BRANCH_TRANSFER = 'reject-branch-transfer',

  //Accounting Module Permissions
  CREATE_GL_ACCOUNT = 'create-gl-account',
  EDIT_GL_ACCOUNT = 'edit-gl-account',
  APPROVE_GL_ACCOUNT = 'approve-gl-account',
  REJECT_GL_ACCOUNT = 'reject-gl-account',
  INITIATE_EDIT_GL_ACCOUNT = 'initiate-edit-gl-account',
  APPROVE_EDIT_GL_ACCOUNT = 'approve-edit-gl-account',
  VIEW_JOURNAL = 'view-journals',
  VIEW_REPORTS = 'view-reports',
  VIEW_GL_ACCOUNTS = 'view-gl-accounts',
  VIEW_GL_TRANSACTIONS = 'view-gl-transactions',
  BACKDATE_JOURNAL_POSTING = 'backdate-journal-posting',
  LIST_JOURNAL_TRANSACTION = 'list-journal-transaction',
  REVERSE_JOURNAL_TRANSACTION = 'reverse-journal-transaction',
  CREATE_JOURNAL_TRANSACTION = 'create-journal-transaction',
  APPROVE_JOURNAL_TRANSACTION = 'approve-journal-transaction',
  REJECT_JOURNAL_TRANSACTION = 'reject-journal-transaction',
  CREATE_POSTING = 'create-posting',

  CREATE_JOURNAL_ENTRY_CLOSURE = 'create-journal-entry-closure',
  LIST_JOURNAL_ENTRY_CLOSURE = 'list-journal-entry-closure',
  APPROVE_JOURNAL_ENTRY_CLOSURE = 'approve-journal-entry-closure',
  DISABLE_JOURNAL_ENTRY_CLOSURE = 'disable-journal-entry-closure',
  REJECT_JOURNAL_ENTRY_CLOSURE = 'reject-journal-entry-closure',

  CREATE_YEAR_END_ENTRY_CLOSURE = 'create-year-end-entry-closure',
  LIST_YEAR_END_ENTRY_CLOSURE = 'list-year-end-entry-closure',
  APPROVE_YEAR_END_ENTRY_CLOSURE = 'approve-year-end-entry-closure',
  REJECT_YEAR_END_ENTRY_CLOSURE = 'reject-year-end-entry-closure',

  EDIT_CHART_OF_ACCOUNT = 'edit-chart-of-account',
  UNDO_ENTRY_CLOSURE = 'undo-journal-entry-closure',

  //Update Module Permissions
  CREATE_SYSTEM_UPDATE = 'create-system-update',
  EDIT_SYSTEM_UPDATE = 'edit-system-update',

  //IN-APP Notification Module Permissions
  CREATE_IN_APP_NOTIFICATION = 'create-in-app-notification',
  VIEW_IN_APP_NOTIFICATION = 'view-in-app-notification',

  //Notification Preference Permissions
  EDIT_CLIENT_NOTIFICATION_PREFERENCE = 'edit-client-notification-preference',
  VIEW_CLIENT_NOTIFICATION_PREFERENCE = 'view-client-notification-preference',
  EDIT_LOAN_NOTIFICATION_PREFERENCE = 'edit-loan-notification-preference',
  VIEW_LOAN_NOTIFICATION_PREFERENCE = 'view-loan-notification-preference',
  EDIT_DEPOSIT_NOTIFICATION_PREFERENCE = 'edit-deposit-notification-preference',
  VIEW_DEPOSIT_NOTIFICATION_PREFERENCE = 'view-deposit-notification-preference',

  // Corporate Loan Account Permissions
  CREATE_CORPORATE_CLIENT_LOAN_ACCOUNT = 'create-corporate-client-loan-account',
  LIST_CORPORATE_CLIENT_LOAN_ACCOUNT = 'list-corporate-client-loan-account',
  VIEW_CORPORATE_CLIENT_LOAN_ACCOUNT = 'view-corporate-client-loan-account',
  APPROVE_CORPORATE_CLIENT_LOAN_ACCOUNT = 'approve-corporate-client-loan-account',
  POST_CORPORATE_CLIENT_LOAN_REPAYMENT = 'post-corporate-client-loan-repayment',
  DISBURSE_CORPORATE_CLIENT_LOAN = 'disburse-corporate-client-loan',
  REJECT_CORPORATE_CLIENT_LOAN_ACCOUNT = 'reject-corporate-client-loan-account',
  AUTHORIZE_CORPORATE_CLIENT_LOAN_ACCOUNT = 'authorize-corporate-client-loan-account',
  EDIT_CORPORATE_CLIENT_LOAN_NOTIFICATION_PREFERENCE = 'edit-corporate-client-loan-notification-preference',
  VIEW_CORPORATE_CLIENT_LOAN_NOTIFICATION_PREFERENCE = 'view-corporate-client-loan-notification-preference',

  //Report Module Permissions
  RUN_CLIENT_REPORTS = 'run-client-reports',
  RUN_LOAN_REPORTS = 'run-loan-reports',
  RUN_DEPOSIT_REPORTS = 'run-deposit-reports',
  RUN_GROUP_REPORTS = 'run-group-reports',
  RUN_ORGANIZATION_REPORTS = 'run-organization-reports',

  //Support Module Permissions
  CREATE_SUPPORT_CHAT = 'create-support-chat',
  VIEW_SUPPORT_MODULE = 'view-support-module',

  //Franchisee Module Permissions
  CREATE_NEW_FRANCHISEE = 'create-new-franchisee',
  IS_FRANCHISEE = 'is-franchisee',

  //Super User
  SUPER_USER = 'super-user',

  //Other Permissions
  CAN_VIEW_OTHER_AREAS = 'can-view-other-areas',
  CAN_VIEW_OTHER_BRANCHES = 'can-view-other-branches',
  CAN_VIEW_OTHER_LOANOFFICERS = 'can-view-other-loanOfficers',
  RUN_YEAR_END_ENTRY_CLOSURE = 'run-year-end-entry-closure',
}
